import React from 'react';
import PropTypes from 'prop-types';

const SelectEditorSection = ({ choices, ...other }) => (
  <select {...other}>
    {Object.keys(choices).map((key, index) => {
      return <option key={index} value={key}>{choices[ key ]}</option>;
    })}
  </select>
);

SelectEditorSection.propTypes = {
  choices: PropTypes.object.isRequired
};

export default SelectEditorSection;
